const URL = process.env.NODE_ENV === 'production' ? 'https://gis.yfpo.com:9107' : 'https://gis.yfpo.com:9107';
//const URL = process.env.NODE_ENV === 'production' ? 'https://gistest.yfpo.com:9107/' : 'https://gistest.yfpo.com:9107/';
//const URL ="http://localhost:21021/";
//var URL="";
export default URL;